import { FormFieldNamesEnum } from './formFieldNamesEnum'

export const normalizers: { [key in FormFieldNamesEnum]?: (arg0: string) => string } = {
  [FormFieldNamesEnum.RefundAmount]: (val) => {
    if (!Number(val)) {
      return ''
    }
    //strip all the non-numeric characters first...BC
    val = val.replace(/\D/g, '')
    //divide by 100 to get the decimal places
    const v = parseFloat(val) / 100

    //return the fixed with 2 decimal places...BC
    return v.toFixed(2)
  }
}
